import { useQuery } from '@tanstack/react-query';
import { Account } from '../../../types/Account';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchAccount = async (uuid: string, template?: string) => {
  const config = template ? { params: { template } } : {};
  const response = await CustomAxios.get<Account>(`accounts/${uuid}`, config);
  const { data } = response;
  return data;
};

interface UseGetAccountByIdProps {
  uuid: string;
  enabled?: boolean;
  template?: string;
}

export function useGetAccountById({ uuid, enabled = true, template }: UseGetAccountByIdProps) {
  const query = useQuery({
    enabled: enabled,
    queryKey: [queryKeys.allAccounts, uuid],
    queryFn: () => fetchAccount(uuid, template),
  });

  return query;
}
